import { PROFFIT_TOP_USER_VOICE_IMAGE_CAREER_LINK, PROFFIT_TOP_USER_VOICE_IMAGE_KAO, PROFFIT_TOP_USER_VOICE_IMAGE_KOKUYO, PROFFIT_TOP_USER_VOICE_IMAGE_NSG, PROFFIT_TOP_USER_VOICE_IMAGE_PANASONIC, PROFFIT_TOP_USER_VOICE_IMAGE_TSNETWORK, PROFFIT_TOP_USER_VOICE_IMAGE_YOKOGAWA, } from '@/utils/constants/assets/s3';
export const topUserVoiceSliderItems = [
    {
        company: '日本板硝子株式会社',
        content: '私の部門では大規模なコンサルプロジェクトというよりも、自社の検討をサポートをしてもらうために特定領域の専門家に伴走支援してもらうことが多いです。そのため、どの部分を自社が検討し、どこをコンサルに任せるか、その役割分担に悩むことが多くあります。\n\nそもそもどのようなことをコンサルに任せられるのかが分からないことも多いため、PROFFITのアドバイザーから任せ方の選択肢を出してもらえることはとても助かります。出してもらった選択肢をもとに、社内メンバーを交えて議論することで、自分たちでやるべきこと、コンサルに任せた方がよいことを明確にしていくことができます。\n\nコンサルへの期待・役割が決まると、評価の観点も自然と決まり、提案の評価や面談での質問事項などで困ることも減ります。何より、自分たちでやり切ることもはっきりするので、プロジェクトが開始してからのコンサルチームとの連携もスムーズになっていると感じています。',
        division: '建築ガラス事業部',
        head: '徹底的に依頼内容を絞り、役割を決めること',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_NSG.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_NSG.webp,
        },
        name: '栗林 秀成 様',
    },
    {
        company: '花王株式会社',
        content: '化粧品業界はトレンドの移り変わりが激しく、常に新しいことを考え続けなくてはなりません。当然、これまで取り組んだことのない新しい施策も多く、外部のコンサルタントは新たな刺激をもたらすパートナーとしての期待が大きいです。\n\nコンサルに依頼をかける時に最も大事なことは、「どうしたいかは社内で決めておくこと」です。コンサルにたくさんのアイデアを出して頂いても、自分たちが考えていないとよいアイデアを感じ取り、選ぶことができません。こうした状態が続くと、いつまでもしっくりこないという状況が続いてしまいます。\n\nそのため、まずは自社の中で出来る限り検討を行い、自分たちが本当にやりたいことや判断基準、検討する上で難しいことを理解できてから、依頼をするスタイルにこだわるようにしています。\nPROFFITに相談するとコンサルごとの得意領域を比較しやすいので、「検討の難しさを乗り越えるためにどんな得意技を持っているか」を明らかに出来れば、コンサル選びの成功確率が高まります。',
        division: '化粧品事業部門 マステージビジネスグループ',
        head: 'まずは、社内でやってみることが第一歩',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_KAO.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_KAO.webp,
        },
        name: '岩田 有弘 様',
    },
    {
        company: '横河電機株式会社',
        content: 'イノベーションセンターでは、アグリバイオ・ゲノム編集・宇宙・海洋…など幅広い新規テーマについて検討をしているため、「技術トレンド×グローバル」の知見がある外部のスペシャリストをいかに見つけてくるかがとても大事になります。また、調査に終始せず、次のアクションにつながるようなプロジェクトをいかに設計できるかも重要です。\n\nこの二つの条件を満たすコンサル/プロフェッショナルの方はとても少ないため、探すことがとても大変なことが多いですが、妥協をせず「真の専門家」を見つけることにこだわっています。PROFFITではこうした条件の厳しい場合にもご支援してもらえるので大変助かりました。\n\n最終的な発注先の選定にあたっては、専門家の知見の豊富さや調査レポートの内容の充実さを評価することに加え、経営や事業部門がそれらの情報を使って意思決定や行動に移すことができそうかどうかも意識しています。そのため、関連部門には必ず早めの段階から、評価選定プロセスに入ってもらい、コンサルとの面談を通じて気になったことを積極的にぶつけてもらうようにしています。',
        division: 'マーケティング本部イノベーションセンターDXデザイン',
        head: '高い専門性と高い実効性の両面を重視',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_YOKOGAWA.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_YOKOGAWA.webp,
        },
        name: '内田 幸宏 様',
    },
    {
        company: 'ＴＳネットワーク株式会社',
        content: 'ESGへの取組み強化や技術を活用した物流の効率化など、これまでの社内の知見と経験だけでは進めることが難しい案件が多くなっており、外部の専門家の力を借りるシーンが増えています。\n\nコンサル会社に依頼をするときに特に気を付けているのは、こちらの要望を「真に理解していただけるか」という点です。案件が進むにつれ、局所的に要望を把握されて求めた答えにたどり着かないシーンや、大局的に要望を解釈されて本質に迫れないケースも経験しました。そのバランスを意識し、こちらの目線とコンサル会社の目線を合わせるために課題と解決手法を構造化したうえで、共通の理解に繋げていただける、そのための労力を惜しまないことを期待しています。そのため、ご提案をいただく際には、こちらの要望を正しく理解されているか、共通理解を得るためにどのようなコミュニケーションが取れるのかを注意深く見るようにしています。\n\nそのコミュニケーションの真摯さが、当社側のメンバーが提言内容をしっかりと理解でき、進めていきたい/進めていけると自信を持つことにつながり、その自信がプロジェクトを成功させるための大事な要因になっているのではないかと思います。',
        division: '経営企画部',
        head: '自信をもって、実行につなげられるかどうか。',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_TSNETWORK.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_TSNETWORK.webp,
        },
        name: '山越 学 様',
    },
    {
        company: 'キャリアリンク株式会社',
        content: 'コンサル活用のきっかけは、人材不足による切迫感でした。新規事業立ち上げの経験者もいない中、売上拡大につながる新たな仕掛けを検討しなければならず、外部のサポートを受けることにしました。\n\n新規事業を立ち上げるとなると、社内の複数の関わる部門を巻き込みながら進めていく必要があるため、コンサルには知識やノウハウの提供だけでなく、いかに現場を巻き込み、実務に落とし込めるかが大事なポイントだと感じています。\n\n元々「コンサル＝戦略企画」というイメージがあったのですが、実際に提案を募集してみると実務経験者も多く、中には営業同行まで伴走頂きながら社内メンバーにスキル移転してくれるという提案もあり、想像以上に現場業務に入ってもらえることに驚きました。\n\n実務経験のある方からの提案には、実務レベルで起こる問題やその対応策が示されており、そのような経験に基づくノウハウは非常に信頼できます。提案の段階から、実行・実務を想定した質疑を積極的にさせて頂くことを心がけています。',
        division: '営業本部長',
        head: '現場が動ける実務レベルの支援が出来るか',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_CAREER_LINK.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_CAREER_LINK.webp,
        },
        name: '島 健人 様',
        position: '取締役 常務執行役員',
    },
    {
        company: 'コクヨ株式会社',
        content: '新規事業や海外展開等、新しい取組みをスタートする際、外部と連携して進めることが増えていますが、「本当に外部の力を借りるべきなのか」は慎重に検討するようにしています。\n\n外部を活用してスピーディに検討することも大事ですが、社内メンバーがオーナーシップと具体性をもって取り組むことができないと、成果につながらないばかりか、議論すら収束しないということが多くあります。\n\nそのため、可能な限り自社で進めることを前提としつつ、本当に社内ではできない/外部の力を頼らざるを得ないところに絞って依頼をすることを特に気を付けています。\n\n外部に頼ることを絞るということは、同時に社内でやるべきことも具体化にもつながり、当事者の責任も明確になります。こうした状態を作った上で、検討を始めることが、コンサル活用に限らず、外部連携を進める上でとても大事になるのではないかと感じています。',
        division: 'グローバル戦略室',
        head: '社内で「本当にできないことか」を見極める',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_KOKUYO.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_KOKUYO.webp,
        },
        name: '土屋 貴紀 様',
    },
    {
        company: 'パナソニック株式会社',
        content: 'コンサル会社からの提案を受けると、どのファームに頼むと良いか迷うことがあります。\n以前、PROFFITを通じて提案を集めた時にも、同様の悩みがありました。\n\n一社は「独自の提言で議論や意思決定を引っ張ってくれるタイプのコンサル」、もう一社は「社内メンバーの想いや意図を汲み寄り添いながらまとめてくれるコンサル」、どちらも内容は魅力的で、費用水準にも大きな差はありませんでした。\n\nこのように迷ったとき、私が最も大事にしているのは、それぞれの会社と進めた時の未来を想像して、「ゴールの解像度」を高めることです。たとえば、実際に社内のメンバーを巻き込んで議論しているシーン、経営陣に報告するシーン、その時の反応まで具体的に想像して、どちらのコンサルがよりしっくりくるか、自分たちにとっての理想に近づけるのかを徹底的に考えます。そうすることで、自分たちが「本当にやりたいこと」が浮き彫りになり、それが大事な判断軸に変わるのです。',
        division: 'ビジネスイノベーション本部',
        head: '検討完了時の「成果」を徹底的に想像すること',
        image: {
            src: PROFFIT_TOP_USER_VOICE_IMAGE_PANASONIC.base,
            webpSrc: PROFFIT_TOP_USER_VOICE_IMAGE_PANASONIC.webp,
        },
        name: '土生田 晴比古 様',
    },
];
